import React, { useContext, useState, useEffect } from "react";
import ServiceContext from "../WebService/ServiceContext";
import { BasicContext } from '../context/BasicContext'
import ChartA from './ChartA'
import { HibModal } from "./HibModal";
/*
type DashboardPrpos = {
    type: string
}*/


type Show1Type = {
    uid: string,
    year: number,
    ActType: string,
    ActTypeName: string,
    description: string,
    Qualification: number,
    TotalHours: number,
    FinishedHours: number,
    UnfinishedHours: number,
    TotalCos: number,
    FinishedCos: number,
    RecordCompleteDate: string,
    FinishedExam: number,
    ExamID: number,
    ExamCompleteDate: string,
    ISFinish: string,
    FinalCC: string//到期日
}

type ActRow = {
    ActType: string,
    ActTypeName: string,
    year: number,
    description: string,
    state: boolean
    isHide: boolean
    FinalCC?: string//產壽登以外到期日
    LYearComplete?:number
    RYearComplete?:number
}

export default (/*props: DashboardPrpos*/) => {
    const ws = useContext(ServiceContext)
    const bc = useContext(BasicContext)
    const [renderData, setRenderData] = useState<ActRow[]>([])
    const [openChart, setOpenChart] = useState<boolean>(false)
    
    const [openNotice, setOpenNotice] = useState<boolean>(true)


    useEffect(() => {
        let temp: ActRow[] = []
        ws.WebService.asyncGetLowStateDashboard().then(res => {
            let d: ResDatas = res as ResDatas
            
            //item.已完課時數 >= item.應完課時數
            //d.RComplete >= d.RTotal

            
            if (d != undefined && d.LYear != null) {
                const LD: ActRow = {
                    ActType: "A",
                    ActTypeName: "法遵課程(壽)",
                    year: d.LYear,
                    description: "保險業務員每年接受6小時外部排定法令遵循課程",
                    state: (d.LComplete >= d.LTotal),
                    isHide: false
                }
                temp.push(LD)
            }
            if (d != undefined && d.RYear != null) {
                const RD: ActRow = {
                    ActType: "A",
                    ActTypeName: "法遵課程(產)",
                    year: d.RYear,
                    description: "保險業務員每年接受6小時外部排定法令遵循課程",
                    state: (d.RComplete >= d.RTotal),
                    isHide: false
                }
                temp.push(RD)
            }

            if (temp.length == 2) {
                temp[0].isHide = true
            }

            return ws.WebService.asyncGetShowPage1()

        }).then(res => {            
            let d: Show1Type[] = res as Show1Type[]
            d.map((row: Show1Type) => {
                const SD: ActRow = {
                    ActType: row.ActType,
                    ActTypeName: row.ActTypeName,
                    year: row.year,
                    description: row.description,
                    state: (row.ISFinish == "Y"),
                    FinalCC: row.FinalCC,
                    isHide: false
                }
                temp.push(SD)
            })

            if (temp.length > 0) {
                return temp
            }
        }).then(() => {
            setRenderData([...renderData, ...temp])
        })
        return
    }, [])

    //預設的Menu ID
    useEffect(() => {
        if( !bc.PID ){
            bc.setPID('dahboard')
        }
        if( bc.PID =='dahboard' && !bc.BID ){
            bc.setBID('legal')
        }
    }, [bc.PID, bc.BID])

    return (
        <div id="courseDashboard">
            <div className="itemBox">
                <div className="boxBody header"><span>類別</span></div>
                <div className="boxBody header"><span>期間</span></div>
                <div className="boxBody header"><span>說明</span></div>
                <div className="boxBody header"><span>狀態</span></div>
                <div className="boxBody header"><span>其他</span></div>
                {
                    renderData.map((row: ActRow, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                <div key={"rowTypeName" + index} className="boxBody typeName">{row.ActTypeName}</div>
                                <div key={"rowYear" + index} className="boxBody year">
                                    {row.year}
                                    {row.ActType == "A" ? "年期" : "年度"}
                                </div>
                                <div key={"rowDescription" + index} className="boxBody description ">{row.description}</div>
                                <div key={"rowComplete" + index} className={"boxBody " + (row.state ? "is-complete" : "not-complete")}>{row.state ? "已完成" : "未完成"}</div>
                                <div key={"rowOther" + index} className={"boxBody other other-" + row.ActType + "-" + index + (row.isHide ? " hide" : "")}>
                                    {                                     
                                        <button className="hibBtn main" onClick={() => {                                       
                                            bc.setBID("legal")
                                            bc.setPID("list")
                                            bc.setActType(row.ActType)
                                        }}>進入課程</button>
                                    }
                                    {
                                        row.ActType == "A" &&
                                        <button className="hibBtn sub" onClick={() => {
                                            bc.setBID("legal")
                                            setOpenChart(true)
                                        }}>詳細資料</button>
                                    }
                                    {
                                        row.FinalCC != "" && row.FinalCC == "0" ?
                                            <div className="leftDays">最後一天！</div> :
                                        Number(row.FinalCC)  > 0 ?
                                            <div className="leftDays">{`剩下${row.FinalCC}天！`}</div> :
                                            ""
                                    }

                                </div>
                            </React.Fragment>
                        )
                    })
                }
                
                <ChartA 
                    hasDetail={true} 
                    setOpen={openChart} 
                    setClose={()=>{
                        setOpenChart(false)
                    }}
                />
            </div>
        
         <HibModal
            type="confirm"
            className="legalNotice"
            show={openNotice}
            showCross={true}
            confirm={() => {
                setOpenNotice(false)
            }}
            cancel={() => {
                setOpenNotice(false)
            }}
        >
            
            <h4>法令遵循課程 提醒事項</h4>
            <p>
                保險業務員每年應完成其中12單元，重複接受同一單元者，僅記錄1次完訓紀錄。
                法令遵循課程禁止冒名上課及測驗，違反者由所屬公司以保險業務員管理規則第13條第1項辦理撤銷登錄，代上課者若為所屬公司人員，應依內部規定懲處。
            </p>
        </HibModal>
        </div>
    )
}